import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
            <div className="md:col-span-5">
              <Link to="/" className="inline-block">
                <span className="font-heading text-4xl md:text-5xl text-background-50 whitespace-nowrap">
                  韩漫画网
                </span>
              </Link>
              <p className="mt-6 text-sm text-background-300 leading-relaxed max-w-md">
                韩漫画网致力于为广大漫画爱好者提供免费、高清、更新及时的韩国漫画在线阅读服务。我们精心筛选优质韩漫作品，覆盖恋爱、奇幻、动作、悬疑等多种类型，让每一位读者都能在这里找到心仪的漫画。
              </p>
              <div className="flex items-center gap-4 mt-8">
                <a href="#" className="w-10 h-10 rounded-full border border-background-500 flex items-center justify-center hover:border-primary-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-links-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-background-500 flex items-center justify-center hover:border-primary-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-background-500 flex items-center justify-center hover:border-primary-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-movie-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-background-500 flex items-center justify-center hover:border-primary-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line text-lg"></i>
                </a>
              </div>
            </div>

            <div className="md:col-span-3">
              <h4 className="text-xs uppercase tracking-widest text-background-400 font-medium mb-5">热门分类</h4>
              <div className="flex flex-col gap-3">
                <Link to="/category/love" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">恋爱漫画</Link>
                <Link to="/category/fantasy" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">奇幻漫画</Link>
                <Link to="/category/action" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">动作漫画</Link>
                <Link to="/category/suspense" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">悬疑漫画</Link>
                <Link to="/category/comedy" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">搞笑漫画</Link>
              </div>
            </div>

            <div className="md:col-span-2">
              <h4 className="text-xs uppercase tracking-widest text-background-400 font-medium mb-5">快速链接</h4>
              <div className="flex flex-col gap-3">
                <Link to="/" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">首页</Link>
                <Link to="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">关于我们</Link>
                <a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">用户协议</a>
                <a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">隐私政策</a>
                <a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">帮助中心</a>
              </div>
            </div>

            <div className="md:col-span-2">
              <h4 className="text-xs uppercase tracking-widest text-background-400 font-medium mb-5">联系方式</h4>
              <div className="flex flex-col gap-3">
                <p className="text-sm text-background-300">hello@eocesp.cn</p>
                <p className="text-sm text-background-300">商务合作：请发送邮件</p>
                <p className="text-sm text-background-300">工作时间：9:00-18:00</p>
              </div>
            </div>
          </div>

          <div className="mt-14 pt-8 border-t border-background-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2026 韩漫画网 HanManHua.com 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">用户协议</a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}